import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enAU from "../../evos-platform-next/src/lib/locales/en/translation.json";
import ja from "../../evos-platform-next/src/lib/locales/ja/translation.json";

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    lng: "en-AU",
    fallbackLng: "en-AU",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      "en-AU": { translation: enAU },
      ja: { translation: ja },
    },
  });

export default i18n;
